import type { Optional } from '@/models/utils'
import { t } from '@/i18n'

export const EmptyGuid = '00000000-0000-0000-0000-000000000000'

export const replaceItemAt = <T>(arr: Array<T>, item: T, index: number): Array<T> => {
  return [...arr.slice(0, index), item, ...arr.slice(index + 1)]
}

export const parseAdvancedFloat = (val: Optional<string>) => {
  if (!val) return undefined
  return parseFloat(val)
}
export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export const arrayToLimitedString = (arr: string[], limit: number) => {
  if (arr == null || arr.length === 0) return ''
  if (arr.length <= limit) return arr.join(', ')
  return `${arr.slice(0, limit).join(', ')}, ${t('general.plusWeitere', { count: arr.length - limit })}`
}

export function translateObject<T>(obj: T): T {
  if (typeof obj === 'string') {
    const regex = /^{(.*)}$/
    const match = obj.match(regex)
    if (match) {
      // Übersetze mittels t() den extrahierten Schlüssel
      return t(match[1]) as unknown as T
    }
    return obj
  } else if (Array.isArray(obj)) {
    return (obj as unknown[]).map((item) => translateObject(item)) as unknown as T
  } else if (obj && typeof obj === 'object') {
    const result: Record<string, unknown> = {}
    for (const [key, value] of Object.entries(obj)) {
      result[key] = translateObject(value)
    }
    return result as T
  }
  return obj
}

export const hex = {
  normalize: (value: string) => {
    const trimmed = value.trim()
    return trimmed && !trimmed.startsWith('#') ? `#${trimmed}` : trimmed
  },
  isValid: (value: string) => {
    return /^#(?:[0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(value)
  }
}
